/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, {useState} from 'react';
import classNames from 'classnames';
import "../style/css/inputselect.css";

interface Option {
  text: string;
  id: number; 
}

interface Props {
  options: Option[];
  classValue: number;
  onChange: (selectedId: number) => void;
  selectedKey: number
}

const InputSelect: React.FC<Props> = ({ options, classValue, onChange, selectedKey}) => {

  const [selectedIndexL, setSelectedIndexL] = useState<number>()
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIndex = e.target.selectedIndex;
    setSelectedIndexL(selectedIndex)
    const selectedId = options[selectedIndex].id; // Récupérer l'id de l'option sélectionnée
    onChange(selectedId);
  };

  return (

    <select
    id={`${selectedKey}`}
    className={classNames({'class-for-value-1  inputselect': classValue === 1,'class-for-value-2 inputselect': classValue === 2})}
    value={selectedIndexL} 
    onChange={handleChange}>

      {options.map((option, index) => (

        <option key={index} value={index.toString()}>

          {option.text}

        </option>

      ))}

    </select>

  );

};

export default InputSelect;
